import script from "./analytics-list.vue?vue&type=script&setup=true&lang=js"
export * from "./analytics-list.vue?vue&type=script&setup=true&lang=js"

import "./analytics-list.vue?vue&type=style&index=0&id=35752ad9&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35752ad9"]])

export default __exports__